import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import RankCondition from "./Ranking/RankCondition";
import RankList from './Ranking/RankList'
import countryOptions from "./dev/countryOptions";
import axios from "axios";
const { REACT_APP_URI = "/" } = process.env;
class Rank extends Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {
                country: "default",
                category: "訂閱數",
                title: "",
                page: 0,
                channelId: ""
            },
            countryName: "",
            resultNotFoundCountryName: "",
            channelTitleInputValue: "",
            channelIdInputValue: "",
            url: `${REACT_APP_URI}/Rank/?country=default&category=訂閱數&title=&page=0&channelId=&version=2`,
            rankList: {},
            requestPage: 1,
            isCondition: false,
            isLoading: true,
            isRate: false,
            status: -1,
            categoryContent: `, ${props.messages.subscribers}`,
            ipCountry: "",
            isIpCountryLoading: true,
            isSearched: false,
        };
    }
    componentDidMount() {
        this.getIpCountry();
        this.setState(
            {
                categoryContent: `subscribers`
            },
            () => this.getRankList(this.state.url)
        );
    }
    getIpCountry = () => {
        this.setState({ isIpCountryLoading: true });
        fetch(`${REACT_APP_URI}/getMyCountry/`, { credentials: "include" })
            .then(res => res.json())
            .then(res => {
                const countryName = countryOptions.find(
                    i => i.value === res.country
                ).label;
                this.setState({
                    condition: {
                        ...this.state.condition,
                        country: res.country
                    },
                    countryName: countryName,
                    isIpCountryLoading: false
                });
            });
    };
    SearchTypeValidation = (channelTitle) => {
        return channelTitle === "" || channelTitle.includes('www.youtube.com') || channelTitle.includes('youtu.be') ? 'Rank' : 'SearchChannelByKeyword'
    }
    updateUrl = () => {
        // this.setState({ isAdditionalSearchResult: false})
        const { condition } = this.state;
        const { SearchTypeValidation } = this
        const SearchType = SearchTypeValidation(condition.title)
        let urlArgs = Object.entries(condition)
            .map(pairs => {
                const [key, value] = pairs;
                return `${key}=${value}`;
            })
            .join("&");
        const newUrl = `${REACT_APP_URI}/${SearchType}/?${urlArgs}&version=2`;
        if (newUrl !== this.state.url) {
            this.setState({ url: newUrl, isLoading: true }, () =>
                this.getRankList(newUrl, SearchType, condition)
            );
        }
    };
    makeCancelableRequest = () => {
        let call;
        return url => {
            if (call) {
                call.cancel("cancel previous request");
            }
            call = axios.CancelToken.source();
            return axios.get(url, {
                withCredentials: true,
                cancelToken: call.token
            });
        };
    };
    get = this.makeCancelableRequest();
    getChannelRank = (ids, url) => {
        const { token } = this.props.user;
        const { category, country} = this.state.condition
        ids.map(id => { // 取一堆 rank 值
            return fetch(`${REACT_APP_URI}/CalculateChannelRank/`, {
                method: "post",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": token
                },
                body: JSON.stringify({ infoId: id, category: category, country: country})
            })
            .then(res => res.json())
            .then(res => {
                const {rankList} = this.state
                const { list } = rankList[url]
                const index = list.findIndex(i => i.id === id) // 取該 id 所在位置
                this.setState({ rankList: {
                    ...rankList,
                    [url]: {...rankList[url], 
                        list:
                            [
                                ...list.slice(0, index),
                                {...list[index], rank: res.rank},
                                ...list.slice(index+1)
                            ]
                    }
                }}) //給 rank 值
            })
        })
    }
    getRankList = async (url, SearchType, condition) => {
        const { get, getChannelRank } = this;
        try { // 重複 call cancel
            const { rankList } = this.state;
            if (rankList.hasOwnProperty(url)) { // 已取得
                this.setState({ isLoading: false });
            } else {
                await get(url, { withCredentials: true })
                    .then(res => {
                        const { status } = res;
                        this.setState({ status });
                        if(status === 503) throw this.setState({ isLoading: false }) //quata用完
                        else return res.data;
                    })
                    .then(rankList => {
                        const { list, isResponseFromChannelIdOrUrl, isAdditionalSearchResult } = rankList;
                        const { title, channelId, page } = this.state.condition;
                        if (isAdditionalSearchResult && list.length !== 0) this.setState({ condition: {...this.state.condition, country: ''}, resultNotFoundCountryName: this.state.countryName, countryName: ""})
                        if (isResponseFromChannelIdOrUrl && list.length !== 0) {
                            const { country, title } = list[0];
                            const countryName = countryOptions.find(
                                i => i.value === country
                            ).label;
                            this.setState({
                                condition: {
                                    ...this.state.condition,
                                    country: country,
                                    title: title
                                },
                                countryName: countryName,
                                channelTitleInputValue: title
                            });
                        }
                        this.setState({
                            rankList: {
                                ...this.state.rankList,
                                [url]: rankList,
                            },
                            isLoading: false,
                            isCondition: title !== "" || channelId !== "" || page !== 0, // 有無重新查詢按鈕
                        }, () => {
                            if( SearchType === 'SearchChannelByKeyword') {
                                getChannelRank(list.map(i => i.id), url)
                            }
                        })
                    })
            }
        } catch (err) {
            if (
                err.response !== undefined &&
                (err.response.status === 603 || err.response.status === 604)
            ) {
                this.setState({
                    rankList: {
                        ...this.state.rankList,
                        [url]: err.response.data
                    },
                    isLoading: false
                });
            }
            if (axios.isCancel(err)) {
                console.error(`Cancelling previous request: ${err.message}`);
            }
        }
    };
    resetCondition = () => {
        this.setState(
            {
                ...this.state,
                condition: {
                    ...this.state.condition,
                    title: "",
                    page: 0,
                    channelId: ""
                },
                channelTitleInputValue: "",
                channelIdInputValue: "",
                requestPage: 1,
                isLoading: false
            },
            () => this.updateUrl()
        );
    };
    // toggleRate = isRate => this.setState({ isRate })
    toggleRate = category => {
        if (
            category === "月訂閱成長率" ||
            category === "月觀看成長率" ||
            category === "近20支平均互動率"
        ) {
            this.setState({ isRate: true });
        } else this.setState({ isRate: false });
    };
    toggleCategory = (category, categoryContent) => {
        categoryContent === "rank_more"
            ? this.props.history.push(`/InfoList`)
            : this.setState(
                {
                    condition: {
                        ...this.state.condition,
                        category: category,
                        page: 0
                    },
                    requestPage: 1,
                    categoryContent
                },
                () => {
                    this.updateUrl()
                    this.toggleRate(category)
                }
            );
    };
    channelTitleInput = e =>
        this.setState({ channelTitleInputValue: e.target.value });
    channelTitleSubmit = e => {
        const { channelTitleInputValue } = this.state;
        if (channelTitleInputValue !== "") {
            this.setState(
                {
                    condition: {
                        ...this.state.condition,
                        title: channelTitleInputValue,
                        channelId: "",
                        page: 0
                    },
                    requestPage: 1,
                    channelIdInputValue: ""
                },
                () => this.updateUrl()
            );
        }
    };
    channelIdInput = e => {
        this.setState({ channelIdInputValue: e.target.value });
    };
    channelIdSubmit = e => {
        const { channelIdInputValue } = this.state;
        if (channelIdInputValue !== "") {
            this.setState(
                {
                    condition: {
                        ...this.state.condition,
                        title: "",
                        channelId: channelIdInputValue,
                        page: 0
                    },
                    requestPage: 1,
                    channelTitleInputValue: ""
                },
                () => this.updateUrl()
            );
        }
    };
    countrySelect = ({ value = "", label = "" }) => {
        this.setState(
            {
                condition: { ...this.state.condition, country: value, page: 0 },
                countryName: label,
                requestPage: 1
            },
            () => this.updateUrl()
        );
    };
    togglePage = (page) =>{
        const {auth, plan} = this.props.user
        this.setState(
            {
                condition: { ...this.state.condition, page: page - 1 },
                requestPage: parseInt(page, 10)
            },
            () => this.updateUrl()
        );
        (plan === "Free" || auth === "notSignIn") && document.getElementById('rankList').scrollIntoView({ 
            behavior: 'smooth' 
            });
    }
    noneQuataRestart = () => {
        this.setState({ status: -1,}, () => this.updateUrl())
    }
    render() {
        const {
            toggleCategory,
            channelTitleInput,
            channelTitleSubmit,
            channelIdInput,
            channelIdSubmit,
            countrySelect,
            resetCondition,
            togglePage,
            noneQuataRestart
        } = this;
        const {
            channelTitleInputValue,
            channelIdInputValue,
            rankList,
            url,
            isCondition,
            countryName,
            resultNotFoundCountryName,
            requestPage,
            isLoading,
            isRate,
            categoryContent,
            ipCountry,
            isIpCountryLoading,
            isAdditionalSearchResult,
            status
        } = this.state;
        const { country, category, title, channelId } = this.state.condition;
        return (
            <Container>
                {/* <Jumbotron /> */}
                <RankCondition
                    country={country}
                    ipCountry={ipCountry}
                    countrySelect={countrySelect}
                    categoryValue={category}
                    categoryContent={categoryContent}
                    channelTitleInputValue={channelTitleInputValue}
                    toggleCategory={toggleCategory}
                    channelTitleInput={channelTitleInput}
                    channelTitleSubmit={channelTitleSubmit}
                    resetCondition={resetCondition}
                    isIpCountryLoading={isIpCountryLoading}
                />
                <RankList
                title={title}
                channelId={channelId}
                country={country}
                ipCountry={ipCountry}
                countryName={countryName}
                resultNotFoundCountryName={resultNotFoundCountryName}
                category={category}
                categoryContent={categoryContent}
                rankList={rankList}
                url={url}
                isCondition={isCondition}
                resetCondition={resetCondition}
                countrySelect={countrySelect}
                togglePage={togglePage}
                requestPage={requestPage}
                channelIdInputValue={channelIdInputValue}
                channelIdInput={channelIdInput}
                channelIdSubmit={channelIdSubmit}
                channelTitleInputValue={channelTitleInputValue}
                channelTitleInput={channelTitleInput}
                channelTitleSubmit={channelTitleSubmit}
                isLoading={isLoading}
                isRate={isRate}
                isIpCountryLoading={isIpCountryLoading}
                isAdditionalSearchResult={isAdditionalSearchResult}
                status={status}
                noneQuataRestart={noneQuataRestart}
                />
            </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.User,
        messages: state.Messages,
        payment: state.Payment
    };
};
export default connect(mapStateToProps)(Rank);
const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 900px;
    min-height: calc(100vh - 72px);
    padding: 0 0 120px 0;
    background-color: #fafafa;
    border-left: 1px solid #e6e6e6;
    @media (max-width: 900px) {
        padding-top: 50px;
        min-width: 320px;
    }
    scroll-behavior: smooth;
`;



// WEBPACK FOOTER //
// ./src/Ranking.js